export default __webpack_public_path__ + "static/media/footer-logo.d97d24c8.png";